import { render, staticRenderFns } from "./DeletedManagerFilter.vue?vue&type=template&id=33da52da&"
import script from "./DeletedManagerFilter.vue?vue&type=script&lang=js&"
export * from "./DeletedManagerFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports